import {jsx} from 'panel';

import {ControlBarEl} from 'common/widgets/control-bar';
import {DropMenuEl} from 'common/components/drop-menu';
import {BucketPaneEl} from 'common/widgets/bucket-pane';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

import type {QueryEntrySection} from '../index';
import {Action, EntryPart, QuerySuperEntry} from '../types';

export function RowActions({
  el,
  index,
  isPlaceholder,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry;
  index: number;
  isPlaceholder: boolean;
}) {
  const {activeEntry, entryPart} = el.state;

  return (
    <div sel='.mp-query-entry-actions'>
      <div sel='.mp-query-control-bar-container'>
        {!isPlaceholder && (
          <ControlBarEl
            key='entry-actions'
            attrs={{
              elref: `lineActions`,
              theme: `tertiary`,
              'overflow-controls': el.helpers.getEntryOverflowControls(index),
              'overflow-menu-width': 200,
              disabled: el.attr(`disabled`),
            }}
            on={{
              select: (ev: CustomEvent) => el.helpers.onControlSelect(ev.detail.value, index),
            }}
            props={{
              contextPanelTransform: el.helpers.overflowControlsContextPanelTransform,
            }}
          />
        )}
        {/** custom bucketing dropdown */}
        {activeEntry === index && entryPart === EntryPart.CustomBucketing && (
          <div sel='.mp-query-customize-buckets'>
            <DropMenuEl
              attrs={{open: true}}
              on={{
                change: el.helpers.onCustomizeBucketsMenuChange,
                click: (ev) => ev.stopPropagation(),
              }}
            >
              <BucketPaneEl
                attrs={el.helpers.getCustomBucketPaneAttributes()}
                on={{
                  changeSelectedBucket: el.helpers.onChangeSelectedCustomBucket,
                  resetBucket: el.helpers.onResetCustomBucket,
                }}
              />
            </DropMenuEl>
          </div>
        )}
      </div>

      {/** row delete button */}
      {el.helpers.canDeleteEntry() && (
        <ButtonEl
          key='entry-delete-action'
          attrs={{
            elref: `deleteLineButton`,
            theme: ButtonTheme.Tertiary,
            icon: `trashcan`,
            role: `button`,
            disabled: el.attr(`disabled`),
          }}
          on={{
            click: () => el.helpers.onEventActionClick(Action.Remove, index),
          }}
        />
      )}
    </div>
  );
}
